<template>
	<div class="sf-datatable-wrapper">
		<sf-data-table
			ref="dataTable"
			:scrId="scrId"
			:paging="false"
			:columns="columns"
			:rows="rows"
			:stripe="false"
			index
			style="height: 300px"
		>
		</sf-data-table>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/RoApcn/store/helpers';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.cmpnPartList;
		},
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001037'), //END 품번
					prop: 'partNo',
					minWidth: '120px',
					sortable: false,
					highlight: true,
					clickEvent: this.clickOpCd
				},
				{
					label: this.getMessage_('QWCC000957'), //END 품명
					prop: 'partNm',
					minWidth: '120px',
					sortable: false
				},
				// {
				// 	label: this.getMessage_('QWCC001096'), //OP코드
				// 	prop: 'opCd',
				// 	minWidth: '150px'
				// },
				// {
				// 	label: this.getMessage_('QWCC001807'), //OP코드명
				// 	prop: 'opNm',
				// 	minWidth: '150px'
				// },
				{
					label: this.getMessage_('QWCC001040'), // 부품가격
					prop: 'partCst',
					minWidth: '200px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001100'), //LTS
					prop: 'lts',
					minWidth: '150px',
					sortable: false
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		//선택된 Rows 정보
		getSelectedRows() {
			const selectedRow = this.$refs.dataTable.getSelectedRows();
			return selectedRow;
		}
	}
};
</script>
